var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowUpFillBlueIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6667H14C14.1215 12.6663 14.2406 12.6328 14.3444 12.5698C14.4483 12.5067 14.533 12.4166 14.5895 12.309C14.6459 12.2014 14.6719 12.0804 14.6647 11.9592C14.6575 11.8379 14.6174 11.7208 14.5487 11.6207L8.54866 2.95401C8.3 2.59468 7.70133 2.59468 7.452 2.95401L1.452 11.6207C1.38255 11.7206 1.34182 11.8377 1.33424 11.9592C1.32666 12.0807 1.35252 12.2019 1.40901 12.3097C1.46549 12.4176 1.55045 12.5078 1.65464 12.5708C1.75883 12.6337 1.87828 12.6669 2 12.6667Z",
    fill: "#6B70FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUpFillBlueIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowUpFillBlueIcon.c4f77894.svg";
export { ForwardRef as ReactComponent };